import { render, staticRenderFns } from "./metta-world.vue?vue&type=template&id=4ef8f5d0&scoped=true"
import script from "./metta-world.vue?vue&type=script&lang=js"
export * from "./metta-world.vue?vue&type=script&lang=js"
import style0 from "./metta-world.vue?vue&type=style&index=0&id=4ef8f5d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef8f5d0",
  null
  
)

export default component.exports